var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F2EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4619 16.3C15.4974 16.3 16.3369 17.1395 16.3369 18.175C16.3369 19.2105 15.4974 20.05 14.4619 20.05C14.1272 20.05 13.813 19.9623 13.541 19.8087L12.5697 21.3244C12.3982 21.5922 12.2934 21.8962 12.263 22.2109L12.2537 22.4009L12.25 25H15.5V23.75C15.5 21.6789 17.1789 20 19.25 20H25.5C27.5711 20 29.25 21.6789 29.25 23.75V25H32C32.5523 25 33 25.4477 33 26V27.75C33 28.3023 32.5523 28.75 32 28.75H10C9.44772 28.75 9 28.3023 9 27.75V26C9 25.4477 9.44772 25 10 25H11.25L11.2537 22.3997C11.2544 21.8988 11.3803 21.4072 11.6187 20.9692L11.7277 20.7849L12.8199 19.081C12.6714 18.8125 12.5869 18.5036 12.5869 18.175C12.5869 17.1395 13.4263 16.3 14.4619 16.3ZM32 26H10V27.75H32V26ZM25.5 21H19.25C17.7312 21 16.5 22.2312 16.5 23.75V25H28.25V23.75C28.25 22.2312 27.0188 21 25.5 21ZM14.4619 17.3C13.9786 17.3 13.5869 17.6918 13.5869 18.175C13.5869 18.3495 13.6379 18.512 13.7259 18.6485C13.7957 18.6956 13.8477 18.7593 13.8823 18.8304C14.0361 18.9669 14.2393 19.05 14.4619 19.05C14.9451 19.05 15.3369 18.6582 15.3369 18.175C15.3369 17.6918 14.9451 17.3 14.4619 17.3ZM22.25 13C23.9069 13 25.25 14.3431 25.25 16C25.25 17.6569 23.9069 19 22.25 19C20.5931 19 19.25 17.6569 19.25 16C19.25 14.3431 20.5931 13 22.25 13ZM22.25 14C21.1454 14 20.25 14.8954 20.25 16C20.25 17.1046 21.1454 18 22.25 18C23.3546 18 24.25 17.1046 24.25 16C24.25 14.8954 23.3546 14 22.25 14Z",
    fill: "#754FFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillTraining);
export default __webpack_public_path__ + "static/media/skill-training.4a130dbcc9bf97ae1a805f9a47ddffa4.svg";
export { ForwardRef as ReactComponent };